import { graphql } from "gatsby"
import React from "react"

import Blocks from "@blocks/Blocks/Blocks"
import LayoutCol from "@molecules/LayoutCol/LayoutCol"
import LayoutRow from "@organisms/LayoutRow/LayoutRow"

const CoreColumns = ({ columns }) => {
  const columnsMapped = columns?.map((column, index) => {
    if (column?.width.length === 0) {
      let defaultColumnWidth = 100 / columns.length
      column.width = defaultColumnWidth.toFixed(2) + "%"
    }

    const width = Math.ceil(parseInt(column.width) * 0.01 * 12)

    return (
      <LayoutCol key={index} width={width}>
        <Blocks blocks={column.columnBlocks} />
      </LayoutCol>
    )
  })

  const fullWidth = columns && columns[0]?.width === "50.00%"

  return <LayoutRow fullWidth={fullWidth}>{columnsMapped}</LayoutRow>
}

export const query = graphql`
  fragment CoreColumns on WpBlockCoreColumns {
    __typename
    columns {
      className
      width
      columnBlocks {
        ...Blocks
      }
    }
  }
`

export default CoreColumns
